import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import Accounting from '../Accounting';

export default function AccountingPage() {
  return (
    <StandaloneShell title="Accounting">
      {({ darkMode, T }) => (
        <PermissionGate module="accounting" moduleName="Accounting">
          <Accounting darkMode={darkMode} T={T} />
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
